/**
 * 相对路径与绝对路径转换  ab相对转绝对路径,re绝对路径转相对,
*/
export function httpChange(type,data) {
  if(type == 'URL'){
    return data.replace(/(\/dev-api|\/prod-api)/g,process.env.VUE_APP_BASE_URL)
  }else{
    let repl = new RegExp(process.env.VUE_APP_BASE_URL,'g')
    return data.replace(repl,process.env.VUE_APP_BASE_API)
  }
}
